import { Pipe, PipeTransform } from '@angular/core';

import { FallbackReportService } from '@app/fallback-report/local-service/fallback-report.service';
import copy from '@app/fallback-report/table/copy';

/**
 * this class formats a cel of data according to some textual transform.
 */
@Pipe({
  name: 'formatCel'
})
export class FormatCelPipe implements PipeTransform {
  constructor(private localService: FallbackReportService) { }

  /**
   * @param value the value to format
   * @param style the block of styles related to this data, where each column's style will be present
   * @param header the specific column style in the block of styles
   * seeAlso: TableStyle in localService and in the localService/extensions readme
   */
  transform(value: any, style: string, header: string): any {
    if (!style) {
      return value;
    }

    const nfObject = new Intl.NumberFormat('en-US');
    /* eslint-disable radix */
    switch (this.localService.TableCelStyles[style][header]) {
      case this.localService.TableStyle.ComEdRounded:
      case this.localService.TableStyle.BGERounded:
      case this.localService.TableStyle.PECORounded:
      case this.localService.TableStyle.ACERounded:
      case this.localService.TableStyle.DPLRounded:
      case this.localService.TableStyle.PEPCORounded:
        if (value === 0 || value === '0') {
          return 0;
        }
        return parseInt(value) < 5
          ? `${copy.FewerThan} 5`
          : nfObject.format(parseFloat(value));

      case this.localService.TableStyle.ComEdThousands:
      case this.localService.TableStyle.BGEThousands:
      case this.localService.TableStyle.PECOThousands:
      case this.localService.TableStyle.ACEThousands:
      case this.localService.TableStyle.DPLThousands:
      case this.localService.TableStyle.PEPCOThousands:
        return nfObject.format(parseFloat(value));

      case this.localService.TableStyle.ComEdRoundedPercent:
      case this.localService.TableStyle.BGERoundedPercent:
      case this.localService.TableStyle.PECORoundedPercent:
      case this.localService.TableStyle.ACERoundedPercent:
      case this.localService.TableStyle.DPLRoundedPercent:
      case this.localService.TableStyle.PEPCORoundedPercent:
        if (value === 0 || value === '0') {
          return '0%';
        }
        return parseInt(value) < 5
          ? `${copy.LessThan} 5%`
          : nfObject.format(parseFloat(value)) + '%';

      default:
        return value;
    }
    /* eslint-enable radix */
  }
}
